define('OutSystems/ClientRuntime/NativeHttp',["require", "exports", "tslib", "./modules/Native/IOutSystemsNativeHost", "./NativeHelper", "./Settings"], function (require, exports, tslib_1, IOutSystemsNativeHost_1, NativeHelper, Settings) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createNativeHttpRequest = exports.isNativeHttpPluginAvailable = exports.getNativeHttpPlugin = void 0;
    function getNativeHttpPlugin() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, NativeHelper.ensureNativeReady()];
                    case 1:
                        _a.sent();
                        if (IOutSystemsNativeHost_1.isIOutSystemsNativeHost(window)) {
                            return [2, window.OutSystemsNative.Http];
                        }
                        else {
                            return [2, null];
                        }
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2, null];
                    case 3: return [2];
                }
            });
        });
    }
    exports.getNativeHttpPlugin = getNativeHttpPlugin;
    function isNativeHttpPluginAvailable() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nativeHttp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getNativeHttpPlugin()];
                    case 1:
                        nativeHttp = _a.sent();
                        return [2, !Settings.getEnvParams().ForceXhrCommunication && !!nativeHttp];
                }
            });
        });
    }
    exports.isNativeHttpPluginAvailable = isNativeHttpPluginAvailable;
    function createNativeHttpRequest(method, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nativeHttp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getNativeHttpPlugin()];
                    case 1:
                        nativeHttp = _a.sent();
                        return [2, new NativeRequestHandler(nativeHttp, method, url)];
                }
            });
        });
    }
    exports.createNativeHttpRequest = createNativeHttpRequest;
    var NativeHttpResponse = (function () {
        function NativeHttpResponse(requestHandler, nativeHttp) {
            this.requestHandler = requestHandler;
            this.nativeHttp = nativeHttp;
        }
        Object.defineProperty(NativeHttpResponse.prototype, "complete", {
            get: function () {
                return this.requestHandler.isDone();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(NativeHttpResponse.prototype, "responseUrl", {
            get: function () {
                return this.nativeHttp.responseUrl;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(NativeHttpResponse.prototype, "statusCode", {
            get: function () {
                return this.nativeHttp.status;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(NativeHttpResponse.prototype, "statusText", {
            get: function () {
                return this.nativeHttp.statusText;
            },
            enumerable: false,
            configurable: true
        });
        NativeHttpResponse.prototype.getHeader = function (name) {
            name = name || "";
            return this.nativeHttp.responseHeaders[name.toLowerCase()];
        };
        Object.defineProperty(NativeHttpResponse.prototype, "headers", {
            get: function () {
                return this.nativeHttp.responseHeaders;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(NativeHttpResponse.prototype, "responseText", {
            get: function () {
                return this.nativeHttp.responseText;
            },
            enumerable: false,
            configurable: true
        });
        return NativeHttpResponse;
    }());
    var NativeRequestHandler = (function () {
        function NativeRequestHandler(nativeHttp, method, url) {
            this.nativeRequest = nativeHttp.createRequest(method, url);
            this._url = url;
        }
        Object.defineProperty(NativeRequestHandler.prototype, "url", {
            get: function () {
                return this._url;
            },
            enumerable: false,
            configurable: true
        });
        NativeRequestHandler.prototype.createRequestCallback = function (callback) {
            var _this = this;
            return function (_) {
                var response = new NativeHttpResponse(_this, _this.nativeRequest);
                callback(response);
            };
        };
        NativeRequestHandler.prototype.setTimeout = function (value) {
            this.nativeRequest.setTimeout(value);
        };
        NativeRequestHandler.prototype.setBody = function (body) {
            this.nativeRequest.setBody(body);
        };
        NativeRequestHandler.prototype.setHeader = function (name, value) {
            this.nativeRequest.setHeader(name, value);
        };
        NativeRequestHandler.prototype.isDone = function () {
            return this.nativeRequest.readyState === 4;
        };
        NativeRequestHandler.prototype.send = function () {
            if (!!this.onSuccess) {
                this.nativeRequest.onSuccess = this.createRequestCallback(this.onSuccess);
            }
            if (!!this.onError) {
                this.nativeRequest.onError = this.createRequestCallback(this.onError);
            }
            if (!!this.onTimeout) {
                this.nativeRequest.onTimeout = this.createRequestCallback(this.onTimeout);
            }
            if (!!this.onAbort) {
                this.nativeRequest.onAbort = this.createRequestCallback(this.onAbort);
            }
            if (!!this.onFinish) {
                this.nativeRequest.onFinish = this.createRequestCallback(this.onFinish);
            }
            this.nativeRequest.send();
        };
        NativeRequestHandler.prototype.abort = function () {
            this.nativeRequest.abort();
        };
        return NativeRequestHandler;
    }());
});
//# sourceMappingURL=NativeHttp.js.map;
